import classNames from 'classnames';

const TouchableOpacity = ({className, children, ...props}: any) => {
  return (
    <div
      {...props}
      onClick={props?.onPress || props?.onClick || (() => {})}
      className={classNames('cursor-pointer', className)}
    >
      {children}
    </div>
  );
};

export default TouchableOpacity;
